import React from 'react';
import { Box } from '@mui/material';
import RaceDetailHeader from './RaceDetailHeader';
import WinRateChart from './WinRateChart';
import AiRecommendedHorses from './AiRecommendedHorses';
import AiFocusHorses from './AiFocusHorses';
import HorseDataTable from './HorseDataTable';
import EvBetPanel from './EvBetPanel';
import './raceDetail.css';

function RaceDetailPage({ model }) {
  return (
    <Box className="race-detail-shell">
      <RaceDetailHeader
        raceDate={model.raceDate}
        surfaceLabel={model.surfaceLabel}
        roughness={model.roughness}
        raceConfidence={model.raceConfidence}
        stats={model.stats}
      />

      <Box className="race-detail-hero-grid">
        <Box className="race-detail-main-column">
          <WinRateChart
            chartData={model.chartData}
            eyebrow={model.chartEyebrow}
            title={model.chartTitle}
            oddsLabel={model.chartOddsLabel}
          />
        </Box>
        <Box className="race-detail-side-column">
          <AiRecommendedHorses
            horses={model.recommendedHorses}
            eyebrow={model.recommendEyebrow}
            title={model.recommendTitle}
          />
          <AiFocusHorses
            horses={model.focusHorses}
            eyebrow={model.focusEyebrow}
            title={model.focusTitle}
          />
        </Box>
      </Box>

      <Box sx={{ mt: 2.5 }} id="race-detail-table">
        <HorseDataTable
          horses={model.horses}
          eyebrow={model.tableEyebrow}
          title={model.tableTitle}
          columns={model.tableColumns}
        />
      </Box>

      {model.evBetsPanel && (
        <Box sx={{ mt: 2.5 }}>
          <EvBetPanel
            bets={model.evBetsPanel.bets}
            eyebrow={model.evBetsPanel.eyebrow}
            title={model.evBetsPanel.title}
            emptyText={model.evBetsPanel.emptyText}
          />
        </Box>
      )}
    </Box>
  );
}

export default RaceDetailPage;
